import { z } from 'zod';
import { zStringRequired } from '../../z';
export const dischargeSummaryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        condition: z.array(z.string()).min(1, 'Please select at least one'),
        goalsStatus: zStringRequired(),
        servicesProvided: z.array(z.string()).min(1, 'Please select at least one'),
        careSummary: zStringRequired(),
        conditionOfDischarge: zStringRequired(),
        dischargeDisposition: z.array(z.string()).min(1, 'Please select at least one'),
        dischargeInstructions: zStringRequired(),
        verbalizedUnderstanding: zStringRequired(),
        otherNotes: z.array(z.string()).optional(),
    }),
});
